import { type GetInviteDataResponse } from '@app/client/common/structs/groups/groups';

import { type InviteAcceptCode, type InviteAcceptUrl } from './types';

export function getRemainingInvites(inviteData?: GetInviteDataResponse) {
    return inviteData ? Math.max(0, inviteData.invite_limit - inviteData.invites_consumed) : 0;
}

export function assertInviteGenerated(code?: InviteAcceptCode): code is InviteAcceptCode {
    return Boolean(code);
}

export function assertInviteCopied(url?: InviteAcceptUrl): url is InviteAcceptUrl {
    return Boolean(url);
}
